"use client";

import type { ReactNode } from "react";

import { Magnetic } from "@/components/motion/magnetic";
import { trackAttributes } from "@/lib/analytics/beacon";

// =============================================================================

type SocialLinkProps = {
  href: string;
  label: string;
  children: ReactNode;
};

/**
 * Square network button: the background fills from the bottom on hover and
 * the icon follows the pointer (magnetic).
 */
export function SocialLink({ href, label, children }: SocialLinkProps) {
  return (
    <Magnetic strength={0.35}>
      <a
        {...trackAttributes("NETWORK_CLICK", {
          network: label,
          from: "footer",
        })}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={label}
        title={label}
        className="group relative grid size-12 place-items-center overflow-hidden rounded-[0.625rem] border border-foreground/10 bg-gradient-to-b from-surface-2 to-surface-1 shadow-[inset_0_1px_0_rgb(255_255_255/0.06)] transition-[border-color,box-shadow] duration-500 ease-(--ease-out-expo) hover:border-foreground/40 hover:shadow-[0_10px_30px_-10px_rgb(0_0_0/0.6)]"
      >
        <span
          aria-hidden
          className="absolute inset-0 origin-bottom scale-y-0 rounded-[inherit] bg-foreground transition-transform duration-500 ease-(--ease-out-expo) group-hover:scale-y-100"
        />
        <span className="relative transition-[color,transform] duration-500 ease-(--ease-out-expo) group-hover:scale-110 group-hover:text-background">
          {children}
        </span>
      </a>
    </Magnetic>
  );
}

// =============================================================================
